import { render } from "./mainPage.vue?vue&type=template&id=c4f7dc48"
import script from "./mainPage.vue?vue&type=script&lang=js"
export * from "./mainPage.vue?vue&type=script&lang=js"

import "./mainPage.vue?vue&type=style&index=0&id=c4f7dc48&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__